//ContactBook NextUI 
import { Container, Input, Button, Text, Row, Spacer, User, Modal, Loading, Tooltip, Col } from '@nextui-org/react'
import { collection, getDocs, doc, setDoc, deleteDoc } from "firebase/firestore";
import { firestore, auth } from "../config/firebase";
import { AiOutlineUser, AiFillPhone, AiFillMessage } from 'react-icons/ai';
import React from 'react'
import { toast } from 'react-toastify';
import { IconButton } from './IconButton';
import { TiDeleteOutline } from 'react-icons/ti';
import { HiClipboardCopy, HiOutlineRefresh } from 'react-icons/hi';
import ImportButton from './ImportButton';
import ExportButton from './ExportButton';
import { isMobile } from 'react-device-detect';

const ContactBook = ({phoneNumber}) => {

    //Fetch des contacts de l'utilisateur avec Firebase
    const [contacts, setContacts] = React.useState([])
    const [visible, setVisible] = React.useState(false);
    const [name, setName] = React.useState("");
    const [phone, setPhone] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [searchText, setSearchText] = React.useState("");
    const [searchResult, setSearchResult] = React.useState([]);
    const [searchResultError, setSearchResultError] = React.useState(false);
    const [searchResultErrorText, setSearchResultErrorText] = React.useState("");
    const [openModalDelete, setOpenModalDelete] = React.useState(false);
    const [idContact, setIdContact] = React.useState(null);
    const [editName, setEditName] = React.useState("");
    const [editPhone, setEditPhone] = React.useState("");
    const [editId, setEditId] = React.useState(null);
    const [modalEditVisible, setModalEditVisible] = React.useState(false);
  
    const closeHandler = () => {
        setName("");
        setPhone("");
        setVisible(false);
    };

    const closeHandlerEdit = () => {
        setEditName("");
        setEditPhone("");
        setEditId(null);
        setModalEditVisible(false);
    };
  
    const closeHandlerDelete = () => {
        setOpenModalDelete(false);
    };

    const openHandler = () => {
        setVisible(true);
        setName("");
        setPhone("");
    };

    const openHandlerEdit = async (id, name, phone) => {
        setModalEditVisible(true);
        setName(name)
        setPhone(phone)
        setEditId(id)
    };

    const openHandlerDelete = () => {
        setOpenModalDelete(true);
    };

    const EditContact = async (id) => {
        //Edit contact
        const docRef = doc(firestore, "users", auth.currentUser.uid, "contacts", id);
        await setDoc(docRef, {
            name: editName ? editName : name,
            phone: editPhone ? editPhone : phone,
        });
        toast.success("Contact modifié avec succès");
        setModalEditVisible(false);
        refreshContacts();
    };

    //Search contact by name
    const searchContact = (e) => {
        setSearchText(e.target.value);
        const subCollectionRef = collection(firestore, "users", auth.currentUser.uid, "contacts")
        const querySnapshot = getDocs(subCollectionRef);
        querySnapshot.then((querySnapshot) => {
            const data = querySnapshot.docs.map(doc => doc.data());
            const result = data.filter(contact => contact.name.toLowerCase().includes(e.target.value.toLowerCase()));
            if (result.length > 0) {
                setSearchResult(result);
                setSearchResultError(false);
            } else {
                setSearchResultError(true);
                setSearchResultErrorText("Aucun résultat trouvé pour " + e.target.value);
            }
        })
    }

    //Refresh contacts list
    const refreshContacts = async () => {
        setLoading(true);
        const subCollectionRef = collection(firestore, "users", auth.currentUser.uid, "contacts")
        const querySnapshot = await getDocs(subCollectionRef);
        const dataContacts = [];
        //Ajouter l'uid de chaque contact dans le resultat
        querySnapshot.forEach((doc) => {
            let cont = { ...doc.data(), id: doc.id };
            dataContacts.push(cont);
        });
        setContacts(dataContacts);
        setLoading(false);
    }

    React.useEffect(() => {
        setLoading(true);
        try {
            const getContacts = async () => {
                const subCollectionRef = collection(firestore, "users", auth.currentUser.uid, "contacts")
                const querySnapshot = await getDocs(subCollectionRef);
                const dataContacts = [];
                //Ajouter l'uid de chaque contact dans le resultat
                querySnapshot.forEach((doc) => {
                    let cont = { ...doc.data(), id: doc.id };
                    dataContacts.push(cont);
                });
                setContacts(dataContacts);
            }
            getContacts();
            setLoading(false);
        } catch (e) {
            console.log(e)            
            toast.error("Une erreur est survenue lors de la récupération des contacts.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                theme: "colored",
            })
            setLoading(false);
        }
    }, [])

    //Delete a contact by id and refresh the list of contacts
    const deleteContact = async (id) => {
        setLoading(true);
        const subCollectionRef = collection(firestore, "users", auth.currentUser.uid, "contacts")
        const docRef = doc(subCollectionRef, id);
        await deleteDoc(docRef);
        toast.info("Contact supprimé", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            theme: "colored",
            })
        setOpenModalDelete(false);
        refreshContacts();
        setLoading(false);
    }


    //Get inital of name and do nothing if one word
    const getInitials = (name) => {
        if (name.indexOf(" ") > -1) {
            const nameArray = name.split(" ");
            const firstInitial = nameArray[0].charAt(0);
            const secondInitial = nameArray[1].charAt(0);
            return firstInitial + secondInitial;
        } else {
            return name.charAt(0);
        }
    }

    //Reduire le nom si plus de 14 caractères
    const reduceName = (name) => {
        if (name.length > 14) {
            return name.substring(0, 14) + "...";
        } else {
            return name;
        }
    }

    //Ajouter un contact dans le carnet d'adresses
    const addContact = () => {
        setLoading(true);
        const subCollectionRef = collection(firestore, "users", auth.currentUser.uid, "contacts")
        const docRef = doc(subCollectionRef);
        setDoc(docRef, {
            name: name,
            phone: phone
        });
        toast.info("Contact ajouté", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            theme: "colored",
          })
        setVisible(false);
        setLoading(false);
        refreshContacts();
    }

    return (
        <Container responsive xs css={{ shadow: "$lg",  borderRadius: '$2xl', maxHeight: "100%" }}>
            <Row>
                <Text h3 css={{mt: "$3"}}>Carnet d'adresses</Text>
                <Spacer />
            </Row>
            <Row align='center'>
                <Input
                    rounded
                    bordered
                    size='lg'
                    width='100%'
                    placeholder="Nom, prénom..."
                    color="primary"
                    value={searchText}
                    onChange={(e) => searchContact(e)}
                    />
                    <Spacer x={0.5}/>
                    <Button auto shadow onClick={() => refreshContacts()} color="primary">
                        <HiOutlineRefresh size={20} />
                    </Button>
                    <Spacer x={0.3}/>
                    <Button auto shadow onClick={() => openHandler()} color="success">Ajouter</Button>
            </Row>
            <Spacer y={1}/>

            <div
                style={{
                    height: '300px',
                    overflowY: 'scroll',
                    overflowX: 'hidden',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                }}
            >
            {
                loading ? (
                    <Row align='center' justify='center'>
                        <Loading type='spinner' />
                    </Row>
                ) :
                searchResultError ? (
                    <Text color='red' >{searchResultErrorText}</Text>
                ) : ( searchText === "" ? (
                    contacts.length === 0 ? (
                        <Row align='center' justify='center'>
                            <Text color='primary' b>Aucun contact</Text>
                        </Row>
                    ) : (
                    contacts.map((contact, index) => (
                        <>
                                <Row key={index} align='center' justify='space-between'>

                                        <User
                                            key={contact.phone}
                                            text={getInitials(contact.name)}
                                            name={contact.name}
                                            pointer
                                            size="lg"
                                            onClick={() => openHandlerEdit(contact.id, contact.name, contact.phone)}
                                        />
                                    <Spacer />
                                        <Text color='primary' css={{cursor: "pointer"}} weight={"bold"} onClick={() => phoneNumber(contact.phone)}>{contact.phone}</Text>
                                    <IconButton css={{ backgroundColor: "red", borderRadius: "$2xl"}} onClick={() => { setIdContact(contact.id); openHandlerDelete()}}>
                                        <TiDeleteOutline color='white' size={"25"}/>
                                    </IconButton>
                                    <Spacer x={0.1}/>
                                </Row>
                                <Spacer />
                        </>
                    )))
                ) :
                    searchResult.map((contact, index) => (
                        <>
                                <Row key={index} align='center' justify='space-between'>
                                        <User
                                            key={contact.phone}
                                            text={getInitials(contact.name)}
                                            name={reduceName(contact.name)}
                                            pointer
                                            size="lg"
                                            onClick={() => openHandlerEdit(contact.id, contact.name, contact.phone)}
                                        />
                                    <Spacer />
                                    <Tooltip content={<HiClipboardCopy size={'25'} color="white"/>} placement="top">
                                        <Text color='primary' weight={"bold"}>{contact.phone}</Text>
                                    </Tooltip>
                                    <Spacer x={0.01}/>
                                    <IconButton  onClick={openHandlerDelete}>
                                        <TiDeleteOutline color='white' size={"25"}/>
                                    </IconButton>
                                    <Spacer x={0.1}/>
                                </Row>
                                <Spacer />
                        </>
                    ))
                )
            }
            </div>
            <Spacer y={1}/>
             {/* Afficher sauf sur écran type téléphones */}
           {isMobile ? null : (
                <Row align='center' justify='center'>
                    {
                        contacts.length === 0 ? 
                        <Button shadow disabled css={{ width: '100%' }} color="primary">Exporter</Button> 
                         : (
                            <ExportButton contacts={contacts}/>
                        )
                    }
                    <Spacer x={1}/>
                    <ImportButton/>
                </Row>
            )}
            <Spacer y={0.5}/>
            <Modal
                closeButton
                open={visible}
                onClose={closeHandler}
                aria-labelledby='Popup enregistrement contact'
            >
                <Modal.Header>
                    <Text b size={18}>
                        Enregistrer un contact
                    </Text>
                </Modal.Header>
                <Modal.Body>
                <Input
                    clearable
                    bordered
                    fullWidth
                    color="primary"
                    size="lg"
                    placeholder="Nom et prénom"
                    contentLeft={<AiOutlineUser />}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <Input
                    clearable
                    bordered
                    fullWidth
                    color="primary"
                    size="lg"
                    placeholder="Numéro de téléphone"
                    maxLength={10}
                    contentLeft={<AiFillPhone />}
                    labelLeft="+33"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />
                </Modal.Body>
                <Modal.Footer>
                <Button auto flat color="error" onPress={closeHandler}>
                    Annuler
                </Button>
                {
                loading ? 
                    <Button auto color={"success"} loading>
                        <Loading type="points" size="sm" />
                    </Button>
                    :                
                    <Button auto color={"success"} onPress={() => addContact()}>
                        Valider
                    </Button>
                }
                </Modal.Footer>
            </Modal>
            <Modal
                closeButton
                open={modalEditVisible}
                onClose={closeHandlerEdit}
                aria-labelledby="Pop modification contact"
            >
                <Modal.Header>
                <Text b size={18}>
                    Modifier un contact
                </Text>
                </Modal.Header>
                <Modal.Body>
                <Input
                    clearable
                    bordered
                    fullWidth
                    color="primary"
                    size="lg"
                    placeholder="Nom et prénom"
                    contentLeft={<AiOutlineUser />}
                    value={editName ? editName : name}
                    onChange={(e) => setEditName(e.target.value)}
                />
                <Input
                    clearable
                    bordered
                    fullWidth
                    color="primary"
                    size="lg"
                    placeholder="Numéro de téléphone"
                    maxLength={10}
                    contentLeft={<AiFillPhone />}
                    labelLeft="+33"
                    value={editPhone ? editPhone : phone}
                    onChange={(e) => setEditPhone(e.target.value)}
                />
                </Modal.Body>
                <Modal.Footer>
                <Button auto flat color="error" onPress={closeHandlerEdit}>
                    Annuler
                </Button>
                {
                loading ? 
                    <Button auto color={"success"} loading>
                        <Loading type="points" size="sm" />
                    </Button>
                    :                
                    <Button auto color={"success"} onPress={() => EditContact(editId)}>
                        Valider
                    </Button>
                }
                </Modal.Footer>
            </Modal>
            <Modal
                closeButton
                blur
                aria-labelledby="popup suppression contact"
                open={openModalDelete}
                onClose={closeHandlerDelete}
                > 
                <Modal.Header>
                <Text id="modal-title" size={18}>
                    Voulez-vous supprimez ce contact ?
                </Text>
                </Modal.Header>
                <Modal.Body>
                <Button auto color="error" onPress={() => deleteContact(idContact)}>
                    Comfirmer
                </Button>
                <Button auto color="default" onPress={() => setOpenModalDelete(false)}>
                    Annuler
                </Button>
                </Modal.Body>
            </Modal>
        </Container>
    )
}

export default ContactBook